export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: '',
        recaptcha_response: '',
      },
      validation: {},
    };
  },
  computed: {
    contactFormCaptcha() {
      return this.$store.getters.CONTACT_FORM_CAPTCHA;
    }
  },
  watch: {
    async contactFormCaptcha(val, oldVal) {
      if (val !== oldVal && val) {
        this.form.recaptcha_response = val;
        this.$store.dispatch('SET_CONTACT_FORM_CAPTCHA', null);

        const loader = this.$loading.show();

        try {
          const response = await this.axios.post('contacts',
              this.form);

          this.initValidation();

          if (response.data.success) {
            this.initFormData();
            this.toast(this.$t('success'), response.data.message);
          } else if (response.data.errors.length > 0
              && typeof this.validation !== 'undefined') {
            response.data.errors.forEach((error) => {
              if (typeof this.validation[error.field] !== 'undefined') {
                this.validation[error.field].valid = false;
                this.validation[error.field].message = error.message;
              }
            });

            this.toast(this.$t('error'), response.data.message, 'danger');
          } else if (response.data.message !== '') {
            this.toast(this.$t('error'), response.data.message, 'danger');
          }
          loader.hide();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
          loader.hide();
        }
      }
    }
  },
  methods: {
    initFormData() {
      if (this.user) {
        this.form.name = `${this.user.first_name} ${this.user.last_name}`;
        this.form.email = this.user.email;
      } else {
        this.form.name = '';
        this.form.email = '';
      }

      this.form.message = '';
      this.form.recaptcha_response = '';
    },
    initValidation() {
      this.validation = {
        name: {
          valid: null,
          message: '',
        },
        email: {
          valid: null,
          message: '',
        },
        message: {
          valid: null,
          message: '',
        },
      };
    },
    onSubmit() {
      this.showContactModal();
    },
  },
  created() {
    this.initValidation();
    this.initFormData();
  },
};
